import PropTypes from 'prop-types';

export default PropTypes.shape({
  header: PropTypes.shape({
    css: PropTypes.any,
    js: PropTypes.any,
    html: PropTypes.any,
  }),
  footer: PropTypes.shape({
    css: PropTypes.any,
    js: PropTypes.any,
    html: PropTypes.any,
  }),
});
